"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eleven/sections/teamsSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type TeamsSectionTeamElevenFadeInUpsItem = {
    key: Key | null | undefined;
    /** Detected variants: "Chief Cosmetic Surgeon" | "Body Contouring Expert" | "Aesthetic Dermatologist" | "Breast Aesthetic Surgeon" */
    span0Text: ReactNode;
    /** Detected variants: "Dr. Sebastian Clark" | "Dr. Isabella Monroe" | "Dr. Alexander Brooks" | "Dr. Genevieve Carter" */
    h30Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/team/team-eleven-1.jpg" | "/Templates/Doccure/img/team/team-eleven-2.jpg" | "/Templates/Doccure/img/team/team-eleven-3.jpg" | "/Templates/Doccure/img/team/team-eleven-4.jpg" */
    src: string;
    /** Detected variants: "team-item-eleven wow fadeInUp" */
    className?: string;
    /** Detected variants: "1s" */
    dataWowDuration?: string;
    /** Detected variants: "team-left" */
    div0ClassName?: string;
    /** Detected variants: "team-header" */
    div0ClassName2?: string;
    /** Detected variants: "designation" */
    span0ClassName?: string;
    /** Detected variants: "team-name" */
    div1ClassName?: string;
    /** Detected variants: "name" */
    h30ClassName?: string;
    /** Detected variants: "team-img" */
    div1ClassName2?: string;
    /** Detected variants: "service" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
    teamSocialItems?: TeamsSectionIconsItem[];
};

type TeamsSectionIconsItem = {
    key: Key | null | undefined;
    /** Detected variants: "fa-brands fa-facebook-f" | "fa-brands fa-youtube" | "fa-brands fa-x-twitter" | "fa-brands fa-linkedin" */
    className: string;
    /** Detected variants: "icon" */
    linkClassName?: string;
    /** Detected variants: "#" */
    href?: string;
};
export type HomeElevenTeamsSectionGeneratedProps = {
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: TeamsSectionTeamElevenFadeInUpsItem) => Partial<ComponentProps<"h3">>);
    divDiv1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TeamsSectionTeamElevenFadeInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    linkLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TeamsSectionIconsItem) => Partial<ComponentProps<typeof SmartLink>>);
    /** Default: "Our Team" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "arrow" */
    sectionDiv0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/arrow-left.svg" */
    sectionDiv0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "arrow" */
    sectionDiv0Div0Div0ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/arrow-right.svg" */
    sectionDiv0Div0Div0ImageWithBasePath1ImageSrc?: string;
    sectionDiv0Div0Div0ImageWithBasePath1ImageVisible?: boolean;
    sectionDiv0Div0Div0ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Our Team Members" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    teamsSectionTeamElevenFadeInUps: TeamsSectionTeamElevenFadeInUpsItem[];
    teamsSectionTeamElevenFadeInUpsItemWrapper?: (item: TeamsSectionTeamElevenFadeInUpsItem, content: ReactNode) => ReactNode;
    teamsSectionTeamElevenFadeInUpsRenderer?: (defaultNode: ReactNode) => ReactNode;
    teamsSectionTeamElevenFadeInUpsImageVisible?: boolean;
    teamsSectionTeamElevenFadeInUpsImageRenderer?: (item: TeamsSectionTeamElevenFadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    teamsSectionTeamElevenFadeInUpsH3Visible?: boolean;
    teamsSectionTeamElevenFadeInUpsH3Renderer?: (item: TeamsSectionTeamElevenFadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    teamsSectionTeamElevenFadeInUpsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TeamsSectionTeamElevenFadeInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    teamsSectionTeamElevenFadeInUpsH3Props?: Partial<ComponentProps<"h3">> | ((item: TeamsSectionTeamElevenFadeInUpsItem) => Partial<ComponentProps<"h3">>);
    teamsSectionIconsItemWrapper?: (item: TeamsSectionIconsItem, content: ReactNode) => ReactNode;
    teamsSectionIconsRenderer?: (defaultNode: ReactNode) => ReactNode;
    teamsSectionIconsLinkVisible?: boolean;
    teamsSectionIconsLinkRenderer?: (item: TeamsSectionIconsItem, defaultNode: ReactNode) => ReactNode;
    teamsSectionIconsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TeamsSectionIconsItem) => Partial<ComponentProps<typeof SmartLink>>);
};

const HomeElevenTeamsSectionGenerated: FC<HomeElevenTeamsSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Our Team",
    sectionDiv0Div0Div0ImageWithBasePath0ImageAlt = "arrow",
    sectionDiv0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/arrow-left.svg",
    sectionDiv0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0ImageWithBasePath1ImageAlt = "arrow",
    sectionDiv0Div0Div0ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/icons/arrow-right.svg",
    sectionDiv0Div0Div0ImageWithBasePath1ImageVisible,
    sectionDiv0Div0Div0ImageWithBasePath1ImageRenderer,
    sectionDiv0Div0Div0ImageWithBasePath1ImageProps,
    sectionDiv0Div0H20H2Text = "Our Team Members",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    divDiv0Div1H30H3Props,
    divDiv1ImageWithBasePath0ImageProps,
    linkLinkProps,
    teamsSectionTeamElevenFadeInUps,
    teamsSectionTeamElevenFadeInUpsItemWrapper,
    teamsSectionTeamElevenFadeInUpsRenderer,
    teamsSectionTeamElevenFadeInUpsImageVisible,
    teamsSectionTeamElevenFadeInUpsImageRenderer,
    teamsSectionTeamElevenFadeInUpsH3Visible,
    teamsSectionTeamElevenFadeInUpsH3Renderer,
    teamsSectionTeamElevenFadeInUpsImageProps,
    teamsSectionTeamElevenFadeInUpsH3Props,
    teamsSectionIconsItemWrapper,
    teamsSectionIconsRenderer,
    teamsSectionIconsLinkVisible,
    teamsSectionIconsLinkRenderer,
    teamsSectionIconsLinkProps,
}) => {
    return (
        <section className="team-section-eleven section">
            <div className="container">
                <div className="section-header section-header-eleven text-center">
                    <div className="title">
                        {renderNode(sectionDiv0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer, (
                            <SmartImage src={sectionDiv0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid icon-1" {...(sectionDiv0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                        ))}
                        {sectionDiv0Div0Div0DivText}
                        {renderNode(sectionDiv0Div0Div0ImageWithBasePath1ImageVisible, sectionDiv0Div0Div0ImageWithBasePath1ImageRenderer, (
                            <SmartImage src={sectionDiv0Div0Div0ImageWithBasePath1ImageSrc} alt={sectionDiv0Div0Div0ImageWithBasePath1ImageAlt} className="img-fluid icon-2" {...(sectionDiv0Div0Div0ImageWithBasePath1ImageProps ?? {})} />
                        ))}
                    </div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>{sectionDiv0Div0H20H2Text}</h2>
                    ))}
                </div>
                {renderCollectionNode(
                    teamsSectionTeamElevenFadeInUps,
                    (item: TeamsSectionTeamElevenFadeInUpsItem) => (
                        <div className={item.className ?? "team-item-eleven wow fadeInUp"} data-wow-duration={item.dataWowDuration ?? "1s"} key={item.key}>
                            <div className={item.div0ClassName ?? "team-left"}>
                                <div className={item.div0ClassName2 ?? "team-header"}>
                                    <span className={item.span0ClassName ?? "designation"}>{item.span0Text}</span>
                                </div>
                                <div className={item.div1ClassName ?? "team-name"}>
                                    {renderItemNode(teamsSectionTeamElevenFadeInUpsH3Visible, teamsSectionTeamElevenFadeInUpsH3Renderer, item, (
                                        <h3 className={item.h30ClassName ?? "name"} {...(typeof teamsSectionTeamElevenFadeInUpsH3Props === "function" ? teamsSectionTeamElevenFadeInUpsH3Props(item) : (teamsSectionTeamElevenFadeInUpsH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>{item.h30Text}</h3>
                                    ))}
                                </div>
                            </div>
                            <div className={item.div1ClassName2 ?? "team-img"}>
                                {renderItemNode(teamsSectionTeamElevenFadeInUpsImageVisible, teamsSectionTeamElevenFadeInUpsImageRenderer, item, (
                                    <SmartImage src={item.src} alt={item.alt ?? "service"} className={item.imageWithBasePath0ClassName ?? "img-fluid"} {...(typeof teamsSectionTeamElevenFadeInUpsImageProps === "function" ? teamsSectionTeamElevenFadeInUpsImageProps(item) : (teamsSectionTeamElevenFadeInUpsImageProps ?? {}))} {...(typeof divDiv1ImageWithBasePath0ImageProps === "function" ? divDiv1ImageWithBasePath0ImageProps(item) : (divDiv1ImageWithBasePath0ImageProps ?? {}))} />
                                ))}
                            </div>
                            <div className="team-social">
                                {renderCollectionNode(
                                    item.teamSocialItems ?? [],
                                    (item: TeamsSectionIconsItem) => (
                                        renderItemNode(teamsSectionIconsLinkVisible, teamsSectionIconsLinkRenderer, item, (
                                            <SmartLink href={item.href ?? "#"} className={item.linkClassName ?? "icon"} {...(typeof teamsSectionIconsLinkProps === "function" ? teamsSectionIconsLinkProps(item) : (teamsSectionIconsLinkProps ?? {}))} {...(typeof linkLinkProps === "function" ? linkLinkProps(item) : (linkLinkProps ?? {}))} key={item.key}>
                                                <i className={item.className} />
                                            </SmartLink>
                                        ))
                                    ),
                                    teamsSectionIconsItemWrapper,
                                    teamsSectionIconsRenderer
                                )}
                            </div>
                        </div>
                    ),
                    teamsSectionTeamElevenFadeInUpsItemWrapper,
                    teamsSectionTeamElevenFadeInUpsRenderer
                )}
            </div>
        </section>
    );
};

export default HomeElevenTeamsSectionGenerated;
